module.exports = __webpack_public_path__ + "bcce11df7960cfe0490e935fcb7328b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (1).png
// module id = 1044
// module chunks = 0